'use strict';

(function () {
    angular
        .module('commons')
        .component('advanceSelectComponent', {
            templateUrl: 'commons/components/advance-select-component.tpl.html',
            controller: function ($timeout, $scope) {
                var vm = this;

                vm.model = {
                    textInputModel: '',
                    typeheadModel: '',
                    allDummyObj: {
                        id : 'D001'
                    }
                };

                vm.$onInit = function () {
                    if (angular.isUndefined(vm.inputMode)) {
                        vm.inputMode = 'text';
                    }
                }

                vm.$onChanges = function (changeObj) {
                    if (vm.isAddAllOptionAvailable &&
                        changeObj.dateSource &&
                        changeObj.dateSource.currentValue &&
                        (changeObj.dateSource.currentValue != changeObj.dateSource.previousValue) &&
                        angular.isUndefined(_.find(changeObj.dateSource.currentValue,{id:'D001'}))
                       ) {
                        vm.model.allDummyObj[vm.selectedValueDisplayField] = ' All';
                        changeObj.dateSource.currentValue.unshift(vm.model.allDummyObj);
                    }

                    if (changeObj.isAllAllSelected &&
                        changeObj.isAllAllSelected.currentValue &&
                        (changeObj.isAllAllSelected.currentValue != changeObj.isAllAllSelected.previousValue) &&
                        !!changeObj.isAllAllSelected.currentValue
                    ) {
                        vm.selectedValues.length = 0;
                        vm.model.allDummyObj[vm.selectedValueDisplayField] = ' All';
                        vm.selectedValues.push(vm.model.allDummyObj);
                    }
                }

                vm.onItemClose = function (item) {
                    var index = vm.selectedValues.indexOf(item);
                    if (index >= 0) {
                        vm.selectedValues.splice(index, 1);
                    }
                }

                vm.onTextInputEnter = function () {
                    if (vm.model.textInputModel.trim().length > 0) {
                        if (vm.selectedValues.indexOf(vm.model.textInputModel) < 0) {
                            vm.selectedValues.push(vm.model.textInputModel);
                        }
                        vm.model.textInputModel = '';
                    }
                }

                vm.onTypeheadEnter = function () {
                    if (!!vm.model.typeheadModel) {
                        if (!!vm.selectedValueDisplayField) {
                            if (vm.selectedValues.indexOf(vm.model.allDummyObj) < 0 && vm.model.typeheadModel instanceof Object && vm.selectedValues.indexOf(vm.model.typeheadModel) < 0) {
                                vm.selectedValues.push(vm.model.typeheadModel);
                            }
                        } else if (vm.selectedValues.indexOf(vm.model.typeheadModel) < 0) {
                            vm.selectedValues.push(vm.model.typeheadModel);
                        }
                        vm.model.typeheadModel = '';
                    }
                }

            },
            bindings: {
                dateSource: '<',
                selectedValues: '=',
                selectedValueDisplayField: '@',
                isAddAllOptionAvailable: '@',
                isAllAllSelected: '<',
                inputFieldLabel: '@',
                inputMode: '@' //text,typehead,list
            }
        });
})
();
